import { normalizeShopProduct } from "./aa-products";

const toNumber = (value, fallback = 0) => {
  const number = Number(value);
  return Number.isFinite(number) ? number : fallback;
};

export function normalizeShopCart(responseData = {}) {
  const data = responseData?.data || responseData || {};
  const items = Array.isArray(data.items) ? data.items : [];

  return {
    items: items.map(normalizeShopCartItem),
    summary: {
      subtotal: toNumber(data.subtotal),
      total: toNumber(data.total),
      currency: data.currency || "USD"
    }
  };
}

export function getCartVariantColor(item = {}) {
  const color = item?.selectedProductColor ?? item?.variant_color ?? null;
  return color && String(color).trim() ? String(color).trim() : null;
}

export function getCartVariantSize(item = {}) {
  const size = item?.selectedProductSize ?? item?.variant_size ?? null;
  return size && String(size).trim() ? String(size).trim() : null;
}

export function hasCartVariant(item = {}) {
  return Boolean(getCartVariantColor(item) || getCartVariantSize(item));
}

export function formatCartVariantSummary(item = {}) {
  return [getCartVariantColor(item), getCartVariantSize(item)].filter(Boolean).join(" · ");
}

export function normalizeShopCartItem(item = {}) {
  const product = normalizeShopProduct(item.product || {}, { canBuy: true });
  const productId = item.product_id ?? product.id;
  const unitPrice = toNumber(item.unit_price ?? product.price);
  const quantity = toNumber(item.quantity, 1);
  const lineTotal = toNumber(item.line_total, unitPrice * quantity);
  const variantColor = item.variant_color ?? null;
  const variantSize = item.variant_size ?? null;

  return {
    ...product,
    id: productId,
    product_id: productId,
    product_variant_id: item.product_variant_id ?? null,
    variant_size: variantSize,
    variant_color: variantColor,
    selectedProductColor: variantColor,
    selectedProductSize: variantSize,
    cartItemId: item.id,
    apiCartItemId: item.id,
    quantity,
    price: unitPrice,
    unit_price: unitPrice,
    line_total: lineTotal,
    stock: product.stock,
    stock_quantity: product.stock_quantity,
    canBuy: true
  };
}
